import { exportTableToExcel } from "./fileExtensions";
import Helper from "../helper/helper";
import { RootStoreSingleton } from "../stores/rootStore";

export const defaultMaterialTableOption = {
    search: true,
    paging: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    grouping: true,
    pageSize: 10,
    emptyRowsWhenPaging: false,
    filtering: true,
    pageSizeOptions: [10, 25, 50]
};

export const productionRolesMaterialTableOption = {
    search: true,
    paging: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    grouping: true,
    pageSize: 10,
    emptyRowsWhenPaging: false,
    filtering: true,
    pageSizeOptions: [10, 25, 50],
    detailPanelType: "single"
};

export const managerReviewEmployeesTableOptions = {
    search: false,
    paging: false,
    exportButton: false,
    exportCsv: exportTableToExcel,
    sorting: false,
    detailPanelType: "single",
    toolbar: true,
};

export const accountsSyncStatusTableOption = {
    search: false,
    paging: false,
    sorting: false,
    detailPanelType: "single",
    toolbar: false
};


export const qarSystemsTableOptions = {
    search: false,
    paging: false,
    headerStyle: {
        "fontWeight": "bold"
    },
    exportButton: true,
    exportCsv: (columns, data) => {
        let totalObj = {
            accounts: 0,
            completedAccounts: 0,
            managers: RootStoreSingleton.qarStore.currentlyReviewedSystemForReview.totalManagerReviews,
            completedManagers: RootStoreSingleton.qarStore.currentlyReviewedSystemForReview.completedManagerReviews
        }

        data.forEach((rowData) => {
            totalObj.accounts += rowData.totalUserAccounts + rowData.totalUnmatchedAccounts;
            totalObj.completedAccounts += rowData.totalReviewedUserAccounts + rowData.totalReviewedUnmatchedAccounts;
        });

        let totalRow = {
            accounts: totalObj.completedAccounts + "/" + totalObj.accounts,
            completedAccounts: (totalObj.completedAccounts / totalObj.accounts * 100).toFixed(2) + " %",
            managers: totalObj.completedManagers + "/" + totalObj.managers,
            completedManagers: (totalObj.completedManagers / totalObj.managers * 100).toFixed(2) + " %"
        }
        let exportData = Object.create(data);
        exportData.push(totalRow);

        exportTableToExcel(columns, exportData);
    }
}

export const qarManagersOptions = {
    search: true,
    paging: true,
    grouping: true,
    pageSize: 10,
    emptyRowsWhenPaging: false,
    filtering: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    exportAllData: true,
    pageSizeOptions: [10, 25, 50, 100],
    detailPanelType: "single",
    actionsColumnIndex: -1,
    filterCellStyle: {
        "textAlign": "center"
    },
    headerStyle: {
        "fontWeight": "bold"
    }
}

export const managerReviewCommentsOptions = {
    search: false,
    paging: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    pageSizeOptions: [5],
    grouping: false,
    toolbar: false,
    filtering: false,
    sorting: false
}

export const reviewHistoryOptions = {
    search: false,
    paging: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    pageSize: 15,
    grouping: false,
    toolbar: false,
    filtering: false,
    sorting: false
}

export const dropDownSelectorTrue = {
    text: "Yes",
    value: true
};

export const dropDownSelectorFalse = {
    text: "No",
    value: false
};

export const isValidDate = (value) => {
    if (value === null || value === undefined) {
        return false;
    }
    return new Date(value).getFullYear() > 1900 ? true : false;
}

export const pendingStatusRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    }
];

export const permissionGroupsManagementColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Description",
        field: "description"
    }
];

export const pendingPgApprovalStatusRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Groups",
        field: "pgs"
    },
    {
        title: "Owner Status",
        field: "ownerStatus"
    }
];

export const pendingPgOwnerApprovalRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Role's Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Group",
        field: "pg"
    },
    {
        title: "PG Owner",
        field: "pgOwner"
    },
    {
        title: "PG Description",
        field: "pgDescription"
    }
];

export const approvedStatusRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Groups",
        field: "pgs"
    },
    {
        title: "Status",
        field: "status"
    }
];

export const waitingForAdditionalApprovalRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Assignee",
        field: "assignee"
    },
    {
        title: "Approver",
        field: "approver"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Groups",
        field: "pgs"
    },
    {
        title: "Status",
        field: "status"
    }
];


export const importantRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Assignee",
        field: "assignee"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Groups",
        field: "pgs"
    },
    {
        title: "Status",
        field: "status"
    }
];

export const productionRolesColumns = [
    {
        title: "Name",
        field: "name"
    },
    {
        title: "Owner",
        field: "owner"
    },
    {
        title: "Creation Date",
        field: "createDate"
    },
    {
        title: "Permission Groups",
        field: "permissionGroups"
    }
];

export const qarSystemsColumns = [
    {
        title: "Domain",
        field: "name",
    },
    {
        title: "Accounts in review",
        field: "accounts"
    },
    {
        title: "Accounts Completeness %",
        field: "completedAccounts"
    },
    {
        title: "Managers to act",
        field: "managers"
    },
    {
        title: "Managers Completeness %",
        field: "completedManagers"
    },
    {
        title: "Due Date",
        field: "dueDate"
    }
]

export const qarManagersColumns = [
    {
        title: "Name",
        field: "employeeFullName"
    },
    {
        title: "Is Completed",
        field: "isCompleted",
        type: 'boolean',
        align: 'center',
        render: rowData => <i className={rowData.isCompleted ? "fas fa-check" : "fas fa-minus"}></i>,
        cellStyle: (e, rowData) => rowData.isCompleted ? { color: "green" } : { color: "red" }
    },
    {
        title: "Escalation Status",
        field: "escalationStatus",
    },
    {
        title: "Review Date",
        field: "reviewDate",
        align: 'center',
        render: rowData => <>{rowData.isCompleted ? new Date(rowData.reviewDate).toLocaleString() : <i className="fas fa-minus"></i>}</>,
    },
    {
        title: "Quarter",
        field: "quarter",
        render: rowData => <>{quarterColumn[rowData.quarter]} </>
    }
]

export const qarAccountGroupsColumns = [
    {
        title: "Name",
        field: "title"
    }
]

export const managerReviewCommentsColumns = [
    {
        title: "Author",
        field: "authorName",
    },
    {
        title: "Content",
        field: "content"
    },
    {
        title: "Creation date",
        render: rowData => <>{new Date(rowData.creationDate).toLocaleString()}</>
    }
]

export const reviewHistoryColumns = [
    {
        title: "Initiator",
        render: rowData => <>{rowData.initiator ? rowData.initiator : "System"}</>
    },
    {
        title: "Account Username",
        render: rowData => <>{rowData.username ? rowData.username : "-"}</>
    },
    {
        title: "Action Taken",
        render: rowData => <>{historyColumnsDic[rowData.actionTaken] || rowData.actionTaken}</>
    },
    {
        title: "Old Value",
        render: rowData => <>{historyColumnsDic[rowData.oldValue] || rowData.oldValue || "-"}</>
    },
    {
        title: "New Value",
        render: rowData => <>{historyColumnsDic[rowData.newValue] || rowData.newValue}</>
    },
    {
        title: "Date",
        render: rowData => <>{new Date(rowData.dateCreated).toLocaleString()}</>
    }
]

const historyColumnsDic = {
    MissingAction: "Missing Action",
    MailForManagersReview: "Initial email",
    MailForManagersReviewReminder: "Reminder email",
    MailForManagersReviewMissedDeadline: "Missed deadline email",
    MailForManagersReviewDelegation: "Delegated employee email",
    TicketLink: "Ticket link",
    DelegatedToId: "Delegated to",
    DelegatedTo: "Delegated",
    DelegatedFromComplianceId: "Delegated from compliance"
}

export const employeesByAccountColumns = [
    {
        title: "Full Name",
        field: "fullName",
    },
    {
        title: "Username",
        field: "username",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Direct Manager",
        field: "managerFullName",
    }
]

export const qarReviewPanelMaterialTableHeaderColumns = ['Employee', 'Title', 'Email', 'Role'];

export const chameleonAdminsMaterialTableHeaderColumns =
    [
        {
            title: "Name",
            field: "fullName"
        },
        {
            title: "Email",
            field: "email"
        },
        {
            title: "Title",
            field: "title"
        },
        {
            title: "Username",
            field: "username"
        },
        {
            title: "Action",
            field: "action",
            align: 'center',
            render: rowData => actionMaps[rowData.action.name]
        },
        {
            title: "Delegate To",
            field: "delegateTo",
            align: 'center',
            render: rowData => rowData.action.delegatedTo !== null ? rowData.action.delegatedTo.fullName : ""
        },
        {
            title: "Ticket",
            field: "ticketId",
            align: 'center',
            render: rowData => rowData.action.ticketId !== null ? rowData.action.ticketId : ""
        },
        {
            title: "Comment",
            field: "comment",
            align: 'center',
            render: rowData => rowData.action.comment !== null ? rowData.action.comment : ""
        },
        {
            title: "Is Completed",
            field: "isChameleonAdmin",
            type: 'boolean',
            align: 'center',
            render: rowData => <i className={rowData.isChameleonAdmin ? "fas fa-check" : "fas fa-minus"}></i>
        }
    ];

export const UnmatchedAccountsColumns = [
    {
        title: "Username",
        field: "userName",
    },
    {
        title: "User",
        field: "firstName",
        render: rowData => <>{rowData.firstName} {rowData.lastName}</>,
        customFilterAndSearch: (term, rowData) => {
            const filter = term.toLowerCase();
            const fName = rowData.firstName ? rowData.firstName.toLowerCase() : rowData.firstName;
            const lName = rowData.lastName ? rowData.lastName.toLowerCase() : rowData.lastName;

            return (fName + ' ' + lName).indexOf(filter) !== -1;
        }
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Title",
        field: "jobTitle",
    },
    {
        title: "Description",
        field: "description",
        exportWidthInPx: 600,
        cellStyle: { width: "10em" }
    },
    {
        title: "Status",
        field: "isActive",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.isActive === true ? <span style={{ "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>,
    },

]

export const actionMaps = {
    0: "Missing Action",
    1: "Approved",
    2: "Revoked",
    3: "Changed",
    4: "Delegated to"
};

export const qarManagersMenuOptions = {
    viewAllReviews: "viewAllReviews",
    viewAllEmployees: "viewAllEmployees",
    viewChameleonAdmins: "viewChameleonAdmins",
    viewUnmatchedAccounts: "viewUnmatchedAccounts",
    viewUnmatchedAccountsInReview: "viewUnmatchedAccountsInReview",
    viewAllDelegatedEmployees: "viewAllDelegatedEmployees"
};


export const applicationPaths = {
    createRole: '/create-role',
    pendingRoles: '/pending-roles',
    pendingPgApprovalRoles: '/pending-pg-approval',
    pendingPgOwnerApproval: '/pending-pg-owner-approval',
    approvedRoles: '/approved-roles',
    pendingAdditionalApprovalRoles: '/pending-additional-approval-roles',
    assignedImportantRoles: '/assigned-important-roles',
    productionRoles: '/production-roles',
    rolesAdminPanel: '/roles-admin-panel',
    permissionGroupsAdminPanel: '/pgs-admin-panel',
    intersectionReports: '/intersection-report',
    inactiveEmployeeAccounts: '/inactive-user-accounts-report',
    qaReview: '/qar-forms',
    soxSystems: '/qar-admin',
    allUserAccountsReport: '/all-user-accounts-report',
    licenseAdminPath: '/license-admin',
    licenseFormsPath: '/license-forms'
};

export const headerItems = {
    reporting: 'reporting',
    roleLifecycle: 'role-lifecycle',
    rolesAdminPanel: 'roles-admin-panel',
    qaReview: 'qa-review-panel',
    soxSystems: 'qar-admin-panel',
    status: 'status',
    licenseAdmin: 'license-admin',
    licenseForms: 'license-forms'
};

export const rbacPermissionGroups = {
    mpAdmin: 'MP_ADMIN',
    mpCiso: 'MP_CISO',
    mpReports: 'MP_REPORTS',
    mpUsers: 'MP_USERS',
    mpManager: 'MP_Manager',
    mpCompliance: 'MP_Compliance',
    mpLicenseAdmin: 'MP_License_Admin',
    mpLicenseManager: 'MP_License_Manager'
};

export const initialPath = 'initialPath';

export const sendMailsConfirmationModal = {
    modalHeader: "Send Mails",
    modalContentDataInPreview: "",
    modalContent: "You will receive a confirmation email after the process is done. Are you sure you want to send emails?"
};

export const delegateEmployeesFromSoxPanel = {
    modalHeader: "The delegation will affect all of the employees accounts, are you sure you want to delegate this employees?",
    modalContent: "Employees Delegation"
};

export const setResponsibleManagerPanel = {
    modalHeader: "Are you sure you want to set responsible manager to this employee?",
    modalContent: "Set Responsible Manager"
};

export const setManagerReviewsCompletedConfirmationModal = {
    modalHeader: "Confirm manager reviews",
    modalContent: "Are you sure you want to mark all manager reviews as completed?"
};

export const uploadManualDataFilValidationErrors = {
    modalHeader: "Validation Errors",
};

export const qarQuarters = {
    q1: 'Q1',
    q2: 'Q2',
    q3: 'Q3',
    q4: 'Q4'
};

export const qarQuartersEnum = {
    'Q1': 0,
    'Q2': 1,
    'Q3': 2,
    'Q4': 3
};

export const quarterColumn = {
    0: 'Q1',
    1: 'Q2',
    2: 'Q3',
    3: 'Q4'
};

export const chameleonSystem = "Chameleon";

export const roleLifecyclePermissionGroups = [rbacPermissionGroups.mpAdmin, rbacPermissionGroups.mpUsers/*, rbacPermissionGroups.mpCiso*/];

export const reportingPermissionGroups = [rbacPermissionGroups.mpAdmin, rbacPermissionGroups.mpReports, rbacPermissionGroups.mpCompliance, rbacPermissionGroups.mpManager/*, rbacPermissionGroups.mpCiso*/];

export const allRbacPermissionGroups = Object.values(rbacPermissionGroups);

export const ManualDataStatus = Object.freeze({
    Initial: 1,
    Processing: 2,
    Finished: 3,
    FinishedWithErrors: 4
});